import { Injectable } from "@angular/core";
@Injectable()
export class OccApiCallClass {
    moduleName: String;
    data: String;
    method: String;
    sessionID: String;
    endUrl: String;
}

